import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import TableCell from "@mui/material/TableCell";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useEffect, useState } from "react";
import ArticleIcon from "@mui/icons-material/Article";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  Menu,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Stack,
  Tooltip,
  useMediaQuery,
  Collapse,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useHistory } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import { deepPurple } from "@mui/material/colors";
import MainDigitalCertificate from "../pages/DSA-NDADComponent/User/Digitalcertificates/DigitallCertificates";
import Login from "../pages/LoginComponent/Login";
import DigitalMedicalCert from "../pages/DSA-NDADComponent/User/Digitalcertificates/DigitalMedicalCertificates";
import MainSignature from "../pages/DSA-NDADComponent/User/SignatureComponent/MainSignature";
import { Link } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import BadgeIcon from "@mui/icons-material/Badge";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { log } from "console";
import { Edit } from "@mui/icons-material";
import Swal from "sweetalert2";
import { APIEndpoint } from "../client/apiconfig";
import axios from "axios";
import MainDocumentPersonal from "../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/MainDetailPersonal";
import SelectPersonalData from "../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/MainPersonDataType";
import IndexDocumentPer from "../pages/DSA-NDADComponent/User/DocumentPersonalComponent/MainDocumentPersonal";
import IndexDocumentPending from "../pages/DSA-NDADComponent/User/PendingDocument/MainDocumentPersonalPending";
import FormPersonal from "../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/FormPersonal";
import MainFormPersonal from "../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/MainFormPersonal"; ///form-personal
import MainFormPersonaNew from "../pages/DSA-NDADComponent/User/FormPersonal/MainFormPersonaNew"; ///form-personal-new
import MainPendingDocument from "../pages/DSA-NDADComponent/User/PendingDocument/MainPendingDocument";
import DetailPersonalAgree from "../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/DetailPersonalAgree";
import IndexDetailPessonalAgree from "../pages/DSA-NDADComponent/User/PersonalDataAgreementComponent/IndexDetailPessonalAgree";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useLocation } from "react-router-dom";
import MainFormPersonaNewV1 from "../pages/DSA-NDADComponent/User/FormPersonal/MainFormPersonaNewV1";
import MainAdminPage from "../pages/DSA-NDADComponent/User/PendingDocument/MainAdminPage";
import MainAdminDocument from "../pages/DSA-NDADComponent/User/PendingDocument/MainAdminDocument";
import {
  APIEndpointWeb,
  GetLocalStorageAccessToken,
  GetLocalStorageOrganization,
  webapi,
} from "../client/web";
// import MainFormPersonalV1 from "../pages/DSA-NDADComponent/User/FormPersonal/MainFormPersonalV1";

const TOP_NAV_HEIGHT = 65;
const drawerWidth = 280;
var Hovermenubutton = 1;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

interface Option {
  value: number;
  label: string;
}

interface IDataOrganization {
  map(
    arg0: (org: any) => import("react/jsx-runtime").JSX.Element
  ): React.ReactNode;
  name_th: string;
  hcode: string;
  hname_eng: string;
  hname_th: string;
}

interface IDataOrganization {
  map(
    arg0: (org: any) => import("react/jsx-runtime").JSX.Element
  ): React.ReactNode;
  name_th: string;
  hcode: string;
  hname_eng: string;
  hname_th: string;
}

interface IDataPer {
  name_th: string;
  organization: IDataOrganization;
}

interface IWaitingApprove {
  waiting_approve_1: number;
  waiting_approve_2: number;
  waiting_approve_3: number;
  waiting_approve_4: number;
}

// Sample data array
const options: Option[] = [
  { value: 10, label: "โรงพยาบาลทดสอบ" },
  { value: 20, label: "Twenty" },
  { value: 30, label: "Thirty" },
];

const HomeLayout: React.FC = (props: any): JSX.Element => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const history = useHistory();
  // Retrieve user data from localStorage
  // const personName = sessionStorage.getItem("Data");
  // const nameData = personName ? JSON.parse(personName) : null;
  // const fullName = nameData?.result?.data?.name_th ?? "Guest";
  // position localStorage
  // const positionName = sessionStorage.getItem("position");
  // const positionData = positionName ? JSON.parse(positionName) : null;
  // const positionfullName = positionData ?? "Guest";

  const [positionfullName, setPositionfullName] = useState<string>("");
  const [fullName, setFullName] = useState<string>("");
  // console.log("positionfullName:", positionfullName); // Debugging line
  const [isSignatureVisible, setIsSignatureVisible] = useState(false);
  const [affiliation, setAffiliation] = useState<number | string>("10");
  const [dataPersonal, setDataPersonal] = useState<IDataPer | null>(null);
  const [dataPersonalTokentype, setDataPersonalTokentype] =
    useState<string>("");

  const [selectedValueAgency, setSelectedValueAgency] = useState<any>(null);

  // menu list
  const location = useLocation();
  const [arraySubMenu] = useState<string[]>([
    "/pending-document",
    "/document-pending",
    "/admin-page-document",
    "/public-health",
  ]);
  const [openSubMenu, setOpenSubMenu] = useState<boolean>(
    arraySubMenu.includes(location.pathname)
  );
  const [accessToken, setAccessToken] = useState<string>(
    GetLocalStorageAccessToken()
  );
  // const [waitingApprove, setWaitingApprove] = useState<IWaitingApprove>({
  //   waiting_approve_1: 0,
  //   waiting_approve_2: 0,
  //   waiting_approve_3: 0,
  //   waiting_approve_4: 0,
  // });
  const [waitingApprove, setWaitingApprove] = useState<IWaitingApprove | null>(null);
  const [localStorageOrganization, setLocalStorageOrganization] =
    useState<any>(null);
  const [checkPage234, setCheckPage234] = useState<string | null>("");

  // const [openSubMenu, setOpenSubMenu] = useState<boolean>(
  //   ["/pending-document", "/document-pending", "/signature"].includes(location.pathname)
  // );
  // const isSelectedMain = ["/pending-document", "/document-pending", "/signature"].includes(location.pathname);

  const handleClick = () => {
    setOpenSubMenu(!openSubMenu);
  };

  useEffect(() => {
    const fetchData = async () => {
      // Check for the user data in localStorage
      let params = new URLSearchParams(document.location.search);
      let page = params.get("page");
      setCheckPage234(page);

      let personData = await sessionStorage.getItem("Data");
      await checkLocalStorageData(personData ? personData : null);
      let glso = GetLocalStorageOrganization();
      setLocalStorageOrganization(glso);
      await getWaitingDocument(glso);
    };
    fetchData();
  }, []);

  const getWaitingDocument = async (glso: any) => {
    try {
      var { data } = await webapi.post(
        `${APIEndpointWeb.GetWaitingDocument}`,
        { hcode: glso?.hcode ? glso.hcode : "" },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setWaitingApprove(data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const historyPushAndSwal = () => {
    // If no data is found, redirect to login and show a warning.
    history.push("/");
    Swal.fire({
      icon: "warning",
      title: "ไม่พบข้อมูลผู้ใช้งาน",
      text: "กรุณาเข้าสู่ระบบก่อนเข้าถึงหน้านี้",
      confirmButtonText: "ตกลง",
    });
  };

  const checkLocalStorageData = async (personData: any) => {
    if (personData) {
      // console.log("window.location.pathname", window.location.pathname)
      try {
        const userData = JSON.parse(personData);
        setFullName(userData?.result?.data?.name_th ?? "Guest");
        // console.log("userData.result", userData.result)
        setDataPersonal(userData.result.data);
        setDataPersonalTokentype(
          userData?.result?.token_type ? userData.result.token_type : ""
        );
        // console.log("userData: ", userData);
        // console.log("userData.result.token_type: ", userData.result.token_type);
        // If the token_type is 'health_id', allow access directly without organization check
        // if (userData.result.token_type === "health_id") {
        //   console.log("No provider access token found");
        //   history.push("/document-personal"); // Redirect directly if token_type is health_id
        //   return;
        // }

        // If token_type is not health_id, check for provider_access_token
        if (!userData.result?.provider_access_token) {
          // alert("No provider access token found");
          historyPushAndSwal(); // Prompt for login if no provider access token
          return;
        }
        if (userData.result.token_type !== "health_id") {
          // For 'provider_id', continue to check organization
          let organization = (await sessionStorage.getItem("organization"))
            ? JSON.parse(sessionStorage.getItem("organization") as string)
            : null;

          // Proceed with organization check only for 'provider_id'
          await checkLocalStorageOrganization(
            organization ? organization : null,
            userData.result.data.organization
          );
        } else {
          var pathnameboolean = arraySubMenu.includes(window.location.pathname);
          if (!pathnameboolean) {
            history.push("/pending-document");
            Swal.fire({
              icon: "error",
              title: "คุณไม่สามารถเข้าถึงหน้านี้ได้",
              // text: "กรุณาเข้าสู่ระบบก่อนเข้าถึงหน้านี้",
              confirmButtonText: "ตกลง",
            });
          }

          // console.log("xxxxx", xxxxx)
          // ["/pending-document", "/document-pending"].includes(window.location.pathname)
          // console.log("เข้า", window.location.pathname)
        }
      } catch (error) {
        setDataPersonal(null);
        console.log(error);
      }
    } else {
      historyPushAndSwal(); // If no data found, prompt for login
    }
  };

  const checkLocalStorageOrganization = (
    Organization: any,
    AllOrganization: any
  ) => {
    if (Organization) {
      // Check if the organization matches the user's organization
      const found = AllOrganization.find(
        (element: any) => element.business_id === Organization.business_id
      );
      if (found) {
        setSelectedValueAgency(found);
        setPositionfullName(Organization.position ?? "Guest");
      } else {
        historyPushAndSwal(); // If no matching organization, prompt for login
      }
    } else {
      // historyPushAndSwal();  // If no organization data found, prompt for login
    }
  };

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    Hovermenubutton = index;
    switch (index) {
      case 1:
        return history.push(index === 1 ? "/e-digitalcert" : "/e-medicalcert");
      case 2:
        return history.push("/signature");
      case 3:
        return history.push(
          index === 3
            ? "/document-personal"
            : index === 4
              ? "/form-personal-new"
              : "/document-signature"
        );
      case 4:
        return history.push("/detail-personal-document");
      case 5:
        return history.push("/pending-document");
      case 6:
        return history.push("/admin-page-document");
      case 7:
        return history.push("/public-health");
      default:
        return history.push("/signature");
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleOpenDialogUserMenu = () => {
    handleClickOpenDialog();
  };

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleLogout = () => {
    // Clear localStorage data and redirect to login page
    sessionStorage.clear();
    history.push("/");
    setOpenDialog(false);
  };

  const handleChangeAffiliation = async (event: any) => {
    await sessionStorage.setItem(
      "organization",
      JSON.stringify(event.target.value)
    );
    await sessionStorage.setItem(
      "hcode",
      JSON.stringify(event.target.value.hcode)
    );
    await setSelectedValueAgency(event.target.value);
    window.location.href = "/document-personal"; // Redirect after updating affiliation
  };

  const SelectPathHeader = (): JSX.Element => {
    switch (window.location.pathname) {
      case "/":
        return <Login />;
      case "/e-digitalcert":
        return <MainDigitalCertificate />; // Render based on role    return <DigitalMedicalCert />;
      case "/e-medicalcert":
        return <DigitalMedicalCert />;
      case "/signature":
        return <MainSignature />;
      case "/document-personal":
        return <MainDocumentPersonal />;
      // case "/document-personal-type":
      //   return <SelectPersonalData />;
      case "/form-personal-new":
        return <MainFormPersonaNewV1 />;
      case "/form-personal":
        return <MainFormPersonal />;
      case "/pending-document":
        return <MainPendingDocument />;
      case "/document-signature":
        return <IndexDocumentPer />;
      case "/document-pending":
        return <IndexDocumentPending />;
      case "/detail-personal-document":
        return <IndexDetailPessonalAgree />;
      case "/admin-page-document":
        return <MainAdminDocument />;
      case "/public-health":
        return <MainAdminDocument />;

      default:
        return <Login />;
    }
  };

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <CssBaseline />
      {/* <CssBaseline /> */}
      <AppBar
        position="fixed"
        open={open}
        style={{ backgroundColor: "#ffffff", width: "100%" }}
        sx={{
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          zIndex: (theme) => theme.zIndex.modal - 999,
        }}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={2}
          sx={{
            minHeight: TOP_NAV_HEIGHT,
            px: 2,
            pl: 0,
          }}
        >
          <Stack alignItems="center" direction="row" spacing={2}>
            {/* เพิ่มรูปโลโก้ */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                p: 2,
              }}
            >
              <Box
                component="img"
                src="/assets/Logo.png"
                sx={{
                  width: { xs: 0, sm: 150, md: 190 }, // ปรับขนาดตามจอ
                  maxWidth: "100%", // ป้องกันการเกินขอบจอ
                }}
              />
            </Box>

            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon />
            </IconButton>
            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerClose}
              sx={{ mr: 2, ...(!open && { display: "none" }) }}
            >
              <MenuIcon />
            </IconButton>
          </Stack>

          <Box sx={{ flexGrow: 0 }}>
            <Stack alignItems="center" direction="row" spacing={2}>
              {/* <Avatar sx={{ bgcolor: deepPurple[500] }}>
                <PersonIcon />
              </Avatar> */}
              <Box>
                <FormControl fullWidth size="small">
                  {dataPersonalTokentype !== "health_id" &&
                    dataPersonal &&
                    dataPersonal.organization ? (
                    <Select
                      displayEmpty
                      id="demo-simple-select"
                      value={selectedValueAgency}
                      onChange={handleChangeAffiliation}
                      sx={{
                        borderRadius: "19px",
                        backgroundColor: "white",
                        width: { xs: 200, sm: 250, md: 300 },
                        border: "1px solid #f8f8f8",
                      }}
                      input={
                        <OutlinedInput
                          startAdornment={
                            <InputAdornment position="start">
                              สังกัด:
                            </InputAdornment>
                          }
                        />
                      }
                    >
                      {dataPersonal &&
                        dataPersonal?.organization?.map((org) => (
                          <MenuItem key={org.hcode} value={org}>
                            {org.hname_th}
                          </MenuItem>
                        ))}
                    </Select>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Box>
              <Avatar sx={{ bgcolor: "#2F4491"[500] }}>
                <PersonIcon />
              </Avatar>
              <Stack direction="column" sx={{ textAlign: "left" }}>
                <Typography
                  color="#13714C"
                  sx={{ fontSize: 14, fontWeight: "500" }}
                >
                  {fullName}
                </Typography>
                <Typography
                  color="#636363"
                  sx={{ fontSize: 12, fontWeight: "400" }}
                >
                  {positionfullName}
                </Typography>
              </Stack>

              <Tooltip title="ออกจากระบบ">
                <IconButton
                  onClick={handleOpenDialogUserMenu}
                  sx={{ p: 0, color: "#13714C" }}
                >
                  <LogoutIcon />
                </IconButton>
              </Tooltip>
            </Stack>

            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
            >
              <MenuItem onClick={handleOpenDialogUserMenu}>
                <Typography textAlign="center">ออกจากระบบ</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Stack>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#FFFFFF",
            marginTop: "100px", // Removed the invalid comment
            zIndex: (theme) => theme.zIndex.modal - 999,
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        {/* <DrawerHeader sx={{ borderBottom: "1px solid #ffffff" }}>
    <Box
      sx={{ display: "flex", justifyContent: "center", width: "100%", p: 2 }}
    >
      <img src="/assets/Logo.png" width={136} />
    </Box>
  </DrawerHeader>
  <Divider /> */}

        <List component="nav" aria-label="main mailbox folders">
          {/* Digital Signature */}
          <Grid>
            {dataPersonalTokentype !== "health_id" && (
              <>
                {waitingApprove === null ? (
                  <ListItemButton
                    disabled
                    sx={{
                      // pl: 4,
                      color: "#0172B9", // สีเทา
                      // "&:hover": { backgroundColor: "transparent" },
                    }}
                  >
                    <ListItemIcon sx={{ color: "#0172B9" }}>
                      <ArticleIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={`ข้อตกลงข้อมูลส่วนบุคคล (DSA) (0)`}
                    />
                  </ListItemButton>
                ) : waitingApprove.waiting_approve_1 !== -1 ? (
                  <ListItemButton
                    selected={
                      checkPage234 === "1" ||
                      ([
                        "/document-personal",
                        "/form-personal-new",
                        "/form-personal",
                        "/document-signature",
                        "/detail-personal-document",
                      ].includes(window.location.pathname) && !["3"].includes(checkPage234 || ""))
                    }
                    onClick={(event: any) => handleListItemClick(event, 3)}
                    sx={{
                      color: "#0172B9",
                      position: "relative",
                      "&:hover": { backgroundColor: "#DBF6FE" },
                      "&.Mui-selected": {
                        backgroundColor: "#DBF6FE",
                        color: "#0172B9",
                        "&:hover": { backgroundColor: "#DBF6FE" },
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          right: 0,
                          bottom: 0,
                          width: "4px",
                          backgroundColor: "#0172B9",
                        },
                      },
                    }}
                  >
                    <ListItemIcon sx={{ color: "#0172B9" }}>
                      <ArticleIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={`ข้อตกลงข้อมูลส่วนบุคคล (DSA) (${waitingApprove.waiting_approve_1})`}
                    />
                  </ListItemButton>
                ) : null}
              </>
            )}

            {/* {dataPersonalTokentype !== "health_id" ? (
              <ListItemButton
                selected={
                  checkPage234 === "1" ||
                  ([
                    "/document-personal",
                    "/form-personal-new",
                    "/form-personal",
                    "/document-signature",
                    "/detail-personal-document",
                  ].includes(window.location.pathname) &&
                    !["3"].includes(checkPage234 || ""))
                }
                onClick={(event: any) => handleListItemClick(event, 3)}
                sx={{
                  color: "#0172B9",
                  position: "relative", // ใช้ position relative เพื่อให้สามารถจัดการกับ pseudo-element
                  "&:hover": {
                    backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อถูกเลือก
                    color: "#0172B9",
                    "&:hover": {
                      backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover เมื่อถูกเลือก
                    },
                    // ใช้ pseudo-element ::after เพื่อเพิ่มเส้นด้านข้าง
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      width: "4px", // ความกว้างของเส้นข้าง
                      backgroundColor: "#0172B9", // สีของเส้น
                    },
                  },
                }}
              >

                <ListItemIcon
                  sx={{
                    // color: [
                    //   "/document-personal",
                    //   "/form-personal-new",
                    //   "/form-personal",
                    //   "/document-signature",
                    //   "/detail-personal-document",
                    // ].includes(window.location.pathname)
                    //   ? "#0172B9"
                    //   : "#5B5B5B",
                    color: "#0172B9",
                  }}
                >
                  <ArticleIcon />
                </ListItemIcon>
                <ListItemText
                  primary={`ข้อตกลงข้อมูลส่วนบุคคล (DSA) (${waitingApprove?.waiting_approve_1 ?? 0})`}
                />
              </ListItemButton>

            ) : (
              null
            )} */}


            {/* ใหม่ */}
            <List>
              {/* เมนูหลัก */}

              <ListItemButton
                onClick={handleClick}
                sx={{
                  color: "#0172B9",
                  position: "relative", // ใช้ position relative เพื่อให้สามารถจัดการกับ pseudo-element
                  "&:hover": {
                    backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อถูกเลือก
                    color: "#0172B9",
                    "&:hover": {
                      backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover เมื่อถูกเลือก
                    },
                    // ใช้ pseudo-element ::after เพื่อเพิ่มเส้นด้านข้าง
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      width: "4px", // ความกว้างของเส้นข้าง
                      backgroundColor: "#0172B9", // สีของเส้น
                    },
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: "#0172B9",
                  }}
                >
                  <InsertDriveFileIcon />
                </ListItemIcon>
                <ListItemText primary="เอกสารรออนุมัติ" />
                {openSubMenu || ["2", "3", "4"].includes(checkPage234 || "") ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}
              </ListItemButton>


              {/* เมนูย่อย */}
              {/* {waitingApprove  && ( */}
              <Collapse
                in={openSubMenu || ["2", "3", "4"].includes(checkPage234 || "")}
                timeout="auto"
                unmountOnExit
              >

                <List component="div" disablePadding>
                  {waitingApprove && waitingApprove.waiting_approve_2 !== -1 && (
                    <ListItemButton
                      selected={
                        checkPage234 !== "1" &&
                        ["/pending-document", "/document-pending"].includes(
                          window.location.pathname
                        ) &&
                        !["3", "4"].includes(checkPage234 || "")
                      }
                      onClick={(event: any) => handleListItemClick(event, 5)}
                      sx={{
                        pl: 4,
                        color: "#0172B9",
                        position: "relative", // ใช้ position relative เพื่อให้สามารถจัดการกับ pseudo-element
                        "&:hover": {
                          backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อถูกเลือก
                          color: "#0172B9",
                          "&:hover": {
                            backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover เมื่อถูกเลือก
                          },
                          // ใช้ pseudo-element ::after เพื่อเพิ่มเส้นด้านข้าง
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            width: "4px", // ความกว้างของเส้นข้าง
                            backgroundColor: "#0172B9", // สีของเส้น
                          },
                        },
                      }}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText
                        primary={`พยาน (${waitingApprove.waiting_approve_2})`}
                      />
                    </ListItemButton>
                  )}

                  {waitingApprove && waitingApprove.waiting_approve_3 !== -1 && (
                    <ListItemButton
                      selected={
                        ["/admin-page-document"].includes(
                          window.location.pathname
                        ) || ["3"].includes(checkPage234 || "")
                      }
                      onClick={(event: any) => handleListItemClick(event, 6)}
                      sx={{
                        pl: 4,
                        color: "#0172B9",
                        position: "relative", // ใช้ position relative เพื่อให้สามารถจัดการกับ pseudo-element
                        "&:hover": {
                          backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อถูกเลือก
                          color: "#0172B9",
                          "&:hover": {
                            backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover เมื่อถูกเลือก
                          },
                          // ใช้ pseudo-element ::after เพื่อเพิ่มเส้นด้านข้าง
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            width: "4px", // ความกว้างของเส้นข้าง
                            backgroundColor: "#0172B9", // สีของเส้น
                          },
                        },
                      }}
                    >
                      <ListItemIcon></ListItemIcon>

                      <ListItemText
                        primary={`แอดมิน สสจ (${waitingApprove.waiting_approve_3})`}
                      />
                    </ListItemButton>
                  )}
                  {waitingApprove && waitingApprove.waiting_approve_4 !== -1 && (
                    <ListItemButton
                      selected={
                        ["/public-health"].includes(window.location.pathname) ||
                        ["4"].includes(checkPage234 || "")
                      }
                      onClick={(event: any) => handleListItemClick(event, 7)}
                      sx={{
                        pl: 4,
                        color: "#0172B9",
                        position: "relative", // ใช้ position relative เพื่อให้สามารถจัดการกับ pseudo-element
                        "&:hover": {
                          backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อถูกเลือก
                          color: "#0172B9",
                          "&:hover": {
                            backgroundColor: "#DBF6FE", // สีพื้นหลังเมื่อ hover เมื่อถูกเลือก
                          },
                          // ใช้ pseudo-element ::after เพื่อเพิ่มเส้นด้านข้าง
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            width: "4px", // ความกว้างของเส้นข้าง
                            backgroundColor: "#0172B9", // สีของเส้น
                          },
                        },
                      }}
                    >
                      <ListItemIcon></ListItemIcon>
                      <ListItemText
                        primary={`สสจ (${waitingApprove.waiting_approve_4})`}
                      />
                    </ListItemButton>
                  )}
                </List>

              </Collapse>

              {/* )} */}
            </List>
          </Grid>
          {/* )} */}
        </List>
      </Drawer>

      <Main open={open} sx={{ backgroundColor: "#F5F7FA", minHeight: "100vh" }}>
        <DrawerHeader />
        {SelectPathHeader()}
      </Main>
      {/* <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <div style={{ backgroundColor: "#FFFFFF", height: "22px" }}></div>
      </Paper> */}

      {/* dialoglogout */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="responsive-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            bgcolor: "#FDFDFD", // Background color for the dialog
            borderRadius: "20px",
            boxShadow: 3, // Shadow effect
            width: 400,
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          textAlign={"center"}
          sx={{
            bgcolor: "#F3F4FF",
            color: "#575199",
            fontSize: "18px",
            position: "relative",
          }}
        >
          <AccountCircleIcon
            width={80}
            style={{
              borderRadius: "50%", // Make the image circular
              width: 80,
              height: 80,
              objectFit: "cover", // Ensure the image fits within the circle
            }}
          />
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ bgcolor: "#F3F4FF", color: "#717171" }}>
          <DialogContentText id="alert-dialog-description">
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box sx={{ fontSize: "18px" }}>{fullName}</Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ bgcolor: "#F3F4FF", display: "flex", justifyContent: "center" }}
        >
          <Button
            onClick={handleLogout}
            autoFocus
            variant="outlined"
            sx={{
              fontSize: "16px",
              width: "300px",
              color: "#424243",
              borderRadius: 30,
              border: "1px solid #E1E9E6",
              backgroundColor: "#ffffff",
              "&:hover": {
                backgroundColor: "#6E67C2", // Corrected the background color
                border: "1px solid #6E67C2",
                color: "#ECF1F8", // Corrected the text color
              },
            }}
          >
            <LogoutIcon sx={{ mr: 3 }} />
            ออกจากระบบ
          </Button>
        </DialogActions>
        <DialogContentText
          sx={{ bgcolor: "#F3F4FF", display: "flex", justifyContent: "center" }}
        >
          <Box sx={{ display: "flex", gap: 2, fontSize: 12 }}>
            {" "}
            {/* Added a Box with flex layout */}
            <span>นโยบายความเป็นส่วนตัว</span>
            <span>ข้อกำหนดในการให้บริการ</span>
          </Box>
          <Box sx={{ mt: 6 }}></Box>
        </DialogContentText>
      </Dialog>
    </Box>
  );
};
export default HomeLayout;
